import { defineStore } from 'pinia';
import type { TireLookupByRegistrationNumberResponse } from '~/types/generated-types';
import { useTireSizeContextStore } from './tireSizeContext';

interface TireContextState {
  _tireInformation: TireLookupByRegistrationNumberResponse | undefined;
}

const initialState: () => TireContextState = () => {
  return {
    _tireInformation: undefined,
  };
};

export const useTireContextStore = defineStore('tireContext', {
  state: initialState,
  persist: {
    storage: persistedState.sessionStorage,
  },
  getters: {
    tireInformation: (state: TireContextState): TireLookupByRegistrationNumberResponse | undefined => state._tireInformation,
  },
  actions: {
    changeTireInformation(tireInformation: TireLookupByRegistrationNumberResponse | undefined): void {
      this._tireInformation = tireInformation;
      useTireSizeContextStore().changeTireSizes(tireInformation);
    },
  },
});
